import { render, staticRenderFns } from "./VendorProfileFormFields.vue?vue&type=template&id=93db1664&scoped=true&"
import script from "./VendorProfileFormFields.vue?vue&type=script&lang=js&"
export * from "./VendorProfileFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93db1664",
  null
  
)

export default component.exports